/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Playbar_And_Highlighting_SubtitleInputs */

const en_common_playbar_and_highlighting_subtitle = /** @type {(inputs: Common_Playbar_And_Highlighting_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playbar behavior and highlights`)
};

const es_common_playbar_and_highlighting_subtitle = /** @type {(inputs: Common_Playbar_And_Highlighting_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta barra y resaltados`)
};

/**
* | output |
* | --- |
* | "Playbar behavior and highlights" |
*
* @param {Common_Playbar_And_Highlighting_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_playbar_and_highlighting_subtitle = /** @type {((inputs?: Common_Playbar_And_Highlighting_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Playbar_And_Highlighting_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_playbar_and_highlighting_subtitle(inputs)
	return en_common_playbar_and_highlighting_subtitle(inputs)
});